import { render, staticRenderFns } from "./EditZahl.vue?vue&type=template&id=22fa5710&scoped=true"
import script from "./EditZahl.vue?vue&type=script&lang=ts"
export * from "./EditZahl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa5710",
  null
  
)

export default component.exports